import { NextPageWithLayout } from '../../_app'
import RBhuLayout from '../../../design/RBhu/_layouts/RBhuLayout'
import { ReactElement } from 'react'
import Head from "next/head";
import Find from '../../../components/_common/FindComponent/Find';

const RBHirdetesListaPage: NextPageWithLayout = () => {
  return (
    <>
      {process.env.NODE_ENV === 'production' ? (
        <Head>
          <meta http-equiv="refresh" content="0; url=https://racingbazar.hu" />
        </Head>
      ) : (
        <Find pageUrl="/" />
      )}
    </>
  )
}

export default RBHirdetesListaPage

// ----------------------------------------------------------------------

RBHirdetesListaPage.getLayout = function getLayout(page: ReactElement) {
  return <RBhuLayout>{page}</RBhuLayout>
}
